import { MyreCalendarComponent } from '@myre/ui-primitive-components';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, type ControlValueAccessor } from '@angular/forms';
import { castArray } from 'lodash-es';

export const CALENDAR_PICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CalendarPickerComponent),
  multi: true,
};

@Component({
  selector: 'myre-calendar-picker',
  templateUrl: './calendar-picker.component.html',
  styleUrls: ['./calendar-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CALENDAR_PICKER_VALUE_ACCESSOR],
  imports: [MyreCalendarComponent],
})
export class CalendarPickerComponent implements ControlValueAccessor {
  private _changeDetectionRef = inject(ChangeDetectorRef);

  // TODO: set highlighted dates input, error input
  @Input()
  public id: string;

  @Input()
  public multiSelect = false;

  @Input()
  public readonly = false;

  @Input()
  public nbMonths: number;

  @Input()
  public startAt: Date;

  @Input()
  public minDate: Date;

  @Input()
  public maxDate: Date;

  @Input()
  public dateFilter: (date: Date) => boolean;

  public disabled: boolean;

  public get value(): Date[] {
    return this._value;
  }

  public set value(value: Date | Date[]) {
    if (this.multiSelect === true) {
      this._value = castArray(value);
    } else {
      this._value = Array.isArray(value) ? [value[0]] : [value];
    }

    this._value = this._value.filter(d => !!d);
    this._changeDetectionRef.detectChanges();
  }

  private _value: Date[] = [];

  public writeValue(value: Date[]): void {
    this.value = value;
  }

  public registerOnChange(fn: (value: Date[]) => any): void {
    this._onModelChange = fn;
  }

  public registerOnTouched(fn: () => any): void {
    this._onTouched = fn;
  }

  public setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  public onChange(value: Date[]): void {
    this.value = value;

    this._onModelChange(value);
  }

  private _onModelChange: (value: Date[]) => any = () => {};

  protected _onTouched: () => any = () => {};
}
